module.exports = __webpack_public_path__ + "media/images/logo-27af3a962d824455350b2dbe7e5893af.png";